<template>
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_19099_159803)">
      <path
        class="fill"
        d="M4.38213 15.9541L3.58057 17.3112C3.53524 17.388 3.47523 17.455 3.40397 17.5086C3.33272 17.5621 3.25161 17.6011 3.16529 17.6233C2.99095 17.6682 2.80592 17.642 2.65093 17.5504C2.49593 17.4588 2.38365 17.3095 2.33879 17.1351C2.29393 16.9608 2.32017 16.7758 2.41173 16.6208L3.21414 15.2636C3.25839 15.1848 3.31794 15.1156 3.38929 15.0601C3.46064 15.0046 3.54236 14.964 3.62964 14.9405C3.71693 14.917 3.80802 14.9112 3.89758 14.9235C3.98713 14.9357 4.07335 14.9657 4.15115 15.0117C4.22896 15.0577 4.2968 15.1187 4.35068 15.1913C4.40456 15.2639 4.44339 15.3465 4.46491 15.4343C4.48643 15.5221 4.49019 15.6133 4.47597 15.7025C4.46176 15.7918 4.42985 15.8773 4.38213 15.9541ZM18.6033 12.216H14.5488L11.9423 7.80525C11.898 7.72644 11.8385 7.65726 11.7671 7.60177C11.6958 7.54629 11.6141 7.50562 11.5268 7.48215C11.4395 7.45868 11.3484 7.45288 11.2588 7.4651C11.1693 7.47732 11.0831 7.5073 11.0053 7.5533C10.9275 7.5993 10.8596 7.66037 10.8057 7.73294C10.7519 7.80552 10.713 7.88812 10.6915 7.97591C10.67 8.06369 10.6662 8.1549 10.6804 8.24416C10.6947 8.33342 10.7266 8.41894 10.7743 8.4957L15.9832 17.3112C16.0747 17.4662 16.2241 17.5785 16.3985 17.6233C16.5728 17.6682 16.7578 17.642 16.9128 17.5504C17.0678 17.4588 17.1801 17.3095 17.225 17.1351C17.2698 16.9608 17.2436 16.7758 17.152 16.6208L15.3513 13.5731H18.6033C18.7833 13.5731 18.9559 13.5016 19.0831 13.3744C19.2104 13.2471 19.2819 13.0745 19.2819 12.8945C19.2819 12.7146 19.2104 12.542 19.0831 12.4147C18.9559 12.2875 18.7833 12.216 18.6033 12.216ZM11.0092 12.216H6.59089L12.402 2.38261C12.4936 2.22761 12.5198 2.04259 12.475 1.86825C12.4301 1.69391 12.3178 1.54453 12.1628 1.45297C12.0078 1.36141 11.8228 1.33517 11.6485 1.38003C11.4741 1.42489 11.3247 1.53717 11.2332 1.69216L9.78188 4.1486L8.33058 1.68877C8.28524 1.61202 8.22523 1.54496 8.15398 1.4914C8.08273 1.43785 8.00162 1.39885 7.9153 1.37664C7.74095 1.33178 7.55593 1.35802 7.40093 1.44957C7.24594 1.54113 7.13366 1.69052 7.0888 1.86486C7.04394 2.0392 7.07018 2.22422 7.16174 2.37922L8.99388 5.47945L5.0149 12.216H0.960433C0.780464 12.216 0.607867 12.2875 0.48061 12.4147C0.353353 12.542 0.28186 12.7146 0.28186 12.8945C0.28186 13.0745 0.353353 13.2471 0.48061 13.3744C0.607867 13.5016 0.780464 13.5731 0.960433 13.5731H11.0092C11.1892 13.5731 11.3618 13.5016 11.4891 13.3744C11.6163 13.2471 11.6878 13.0745 11.6878 12.8945C11.6878 12.7146 11.6163 12.542 11.4891 12.4147C11.3618 12.2875 11.1892 12.216 11.0092 12.216Z"
        fill="none"
      />
    </g>
    <defs>
      <clipPath id="clip0_19099_159803">
        <rect
          width="19"
          height="19"
          fill="none"
          transform="translate(0.28186)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AppleIcon",
});
</script>

<style scoped lang="scss">
@use "../icon.scss";
</style>
